module.exports = __webpack_public_path__ + "img/w13-b1.43aac1eb.jpg";